import type { CategoryNode } from '~/types/category'
import { flattenCategoryTree, mapBySlug } from '~/utils/categoryTree'

/** Locale-keyed public tree (`GET /Public/CategoryProduct/tree`). Shared by listing, PDP, similar. */
export function useCategoryTree() {
  const api = useApi()
  const { locale } = useI18n()

  const asyncData = useAsyncData(
    `category-tree:${locale.value}`,
    async () => {
      const raw = await api<CategoryNode[]>('/Public/CategoryProduct/tree')
      return Array.isArray(raw) ? raw : []
    },
    { default: (): CategoryNode[] => [] },
  )

  const flat = computed(() => flattenCategoryTree(asyncData.data.value ?? []))
  const bySlug = computed(() => mapBySlug(flat.value))

  return {
    tree: asyncData.data,
    error: asyncData.error,
    pending: asyncData.pending,
    execute: asyncData.execute,
    ready: asyncData,
    flat,
    bySlug,
  }
}
